import type { NavScript } from '../navigation.ts'

let tabContentsByKey: { [key: string]: string } | null = null

export const onLoad: NavScript['onLoad'] = async () => {
  const main = document.querySelector('main')
  const tabs = Array.from(main?.querySelectorAll('& > details[data-tabgroup]') || [])
  const groups = new Set(tabs.map(tab => tab.getAttribute('data-tabgroup')))

  const getTabKey = (tab: Element) =>
    `${tab.getAttribute('data-tabgroup')}_${(tab?.querySelector('& > summary') as HTMLElement)?.innerText}`

  if (!tabContentsByKey)
    tabContentsByKey = tabs.reduce((acc, cur) => ({ ...acc, [getTabKey(cur)]: cur.innerHTML }), {})

  function onTabClick(ev: MouseEvent) {
    const key = (ev.target as HTMLElement)?.getAttribute('data-tabkey')
    if (key)
      selectTab(key)
  }

  function selectTab(tabKey: string) {
    const content = tabContentsByKey?.[tabKey]
    const tabElem = document.querySelector(`a[data-tabkey="${tabKey}"]`) as HTMLElement
    const tabContainer = tabElem?.closest('ul[data-tabgroup]')
    const contentContainer = tabContainer?.parentElement?.querySelector(`ul[data-tabgroup]:has(a[data-tabkey="${tabKey}"]) + section`)

    // Make sure we've found required elements
    if (!content || !tabElem || !tabContainer || !contentContainer) {
      console.log('Cannot select tab ' + tabKey)
      console.log(content, tabElem, tabContainer, contentContainer)
      return
    }

    // Insert into content container (remove summary from generated html)
    contentContainer.innerHTML = content
    contentContainer.querySelector('& > summary')?.remove()

    // Remove styles from all other tabs in the container
    for (const tab of tabContainer.querySelectorAll('a')) {
      if (tab)
        tab.style.textDecoration = 'none'
    }

    // Style the selected tab
    tabElem.style.textDecoration = 'underline'
  }

  for (const group of groups) {
    const firstTab = main?.querySelector(`& > details[data-tabgroup="${group}"]`)
    const insertTarget = firstTab?.nextSibling
    const insertParent = firstTab?.parentElement
    const currentTabs = tabs.filter(tab => tab.getAttribute('data-tabgroup') === group) as HTMLDetailsElement[]

    // Create tab container
    const tabContainer = document.createElement('ul')
    tabContainer.style.listStyle = 'none'
    tabContainer.style.paddingLeft = '0'
    tabContainer.style.display = 'flex'
    tabContainer.style.flexDirection = 'row'
    tabContainer.setAttribute('data-tabgroup', group || 'unknown')
    insertParent?.insertBefore(tabContainer, insertTarget ?? null)

    // Insert tabs into container
    const tabList = currentTabs.map(tab => (tab.querySelector('& > summary') as HTMLElement)?.innerText)
    for (const tab of tabList) {
      const tabElem = document.createElement('li')
      const link = document.createElement('a')
      link.setAttribute('data-tabkey', `${group}_${tab}`)
      link.innerText = tab
      tabElem.appendChild(link)
      tabContainer.insertBefore(tabElem, null)
      link.addEventListener('click', onTabClick)
      link.style.cursor = 'pointer'
      link.style.margin = '0 16px'
    }

    // Insert container for tab contents to be inserted into
    const contentContainer = document.createElement('section')
    insertParent?.insertBefore(contentContainer, insertTarget ?? null)

    // Prefill container with first tab's contents
    const openTab = currentTabs.find(tab => tab.open) ?? firstTab
    if (openTab) {
      const key = getTabKey(openTab)
      setTimeout(() => {
        selectTab(key)
      }, 10)
    }

  }

  // Remove the details elements
  for (const tab of tabs) {
    tab.parentElement?.removeChild(tab)
  }
}

export const onBeforeUnload: NavScript['onBeforeUnload'] = async () => {
  tabContentsByKey = null

  return { continueUnload: true }
}
